export default __webpack_public_path__ + "static/media/icon-printer.0aac8bab.svg";